import React, { useId } from "react";
import { Label } from "@src/lib/ui/Label";
import { Switch } from "@src/lib/ui/Switch";
import Text from "@src/lib/ui/Text";

export const AdminToolsPanel: React.FC<{
  toolbar?: React.ReactNode;
  children: React.ReactNode;
}> = ({ toolbar, children }) => (
  <div className="flex flex-col">
    {toolbar && (
      <div className="sticky top-0 z-10 border-b border-border-primary bg-bg-primary px-6 py-3">
        {toolbar}
      </div>
    )}
    {children}
  </div>
);

export const AdminToolsRowList: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <div className="flex flex-col divide-y divide-border-secondary">
    {children}
  </div>
);

export const AdminToolsEmptyRow: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <div className="px-6 py-3">
    <Text variant="helper-description" className="text-text-tertiary">
      {children}
    </Text>
  </div>
);

export const AdminToolsToggleRow: React.FC<{
  title: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}> = ({ title, checked, onCheckedChange }) => {
  const id = useId();
  return (
    <div className="flex items-center gap-4 px-6 py-2.5 hover:bg-state-hover">
      <Label htmlFor={id} className="flex-1 cursor-pointer leading-snug">
        {title}
      </Label>
      <Switch id={id} checked={checked} onCheckedChange={onCheckedChange} />
    </div>
  );
};
